import { BoxProps } from '@mui/material'

import iosDownload from './img/download-on-the-app-store.svg'
import iosDownloadNoBorder from './img/download-on-the-app-store-no-border.svg'
import androidDownload from './img/get-it-on-google-play.svg'
import androidDownloadNoBorder from './img/get-it-on-google-play-no-border.svg'
import { useCoinUserEvents } from '../../business-logic/tracking'
import { forget } from '@xylabs/forget'

export interface DownloadButtonBoxProps extends BoxProps {
  android?: boolean
  androidLink?: string
  ios?: boolean
  iosLink?: string
  onIosClick?: () => void
  onAndroidClick?: () => void
  hasBorder?: boolean
  target?: string
}

export const DownloadButtonBox: React.FC<DownloadButtonBoxProps> = (props) => {
  const {
    android = true,
    ios = true,
    androidLink = 'https://play.google.com/store/apps/details?id=network.xyo.coin',
    iosLink = 'https://apps.apple.com/us/app/coin-always-be-earning/id1450443351',
    onIosClick,
    onAndroidClick,
    hasBorder = true,
    target = '_blank'
  } = props
  const userEvents = useCoinUserEvents()
  //TODO - find out if this will work if the target != _blank
  const onMouseDown = () => {
    forget(userEvents.customEvent('InstallLinkClicked'))
  }

  return (
    <div id="oneLinkContainer" className="d-flex flex-row flex-wrap align-items-center justify-content-center">
      {ios ? (
        <a className="m-2 app-install-icon" id="installIos" href={iosLink} target={target} onClick={onIosClick} onMouseDown={onMouseDown} rel="noreferrer">
          <img alt="Available on the AppStore" height="45" src={hasBorder ? iosDownload : iosDownloadNoBorder} />
        </a>
      ) : null}
      {android ? (
        <a className="m-2 app-install-icon" id="installAndroid" href={androidLink} target={target} onClick={onAndroidClick} onMouseDown={onMouseDown} rel="noreferrer">
          <img alt="Get it on Google Play" height="45" src={hasBorder ? androidDownload : androidDownloadNoBorder}/>
        </a>
        ) : null
      }
    </div>
  )
}
